// MET-468: the quote page re-dates a lapsed effective date once per page load.
// A failed write can leave earlier LOBs re-dated, so after a failure this tab
// stops trying and shows the date-choice popup instead, even across reloads.
// sessionStorage keeps that per tab by design: a new tab tries once more.
const keyFor = (applicationGroupId: string) =>
  `met468.effectiveDateAutoUpdateFailed.${applicationGroupId}`;

export const hasEffectiveDateAutoUpdateFailed = (
  applicationGroupId: string
): boolean => {
  try {
    return sessionStorage.getItem(keyFor(applicationGroupId)) !== null;
  } catch {
    // Storage unavailable (e.g. private mode): treat as never failed.
    return false;
  }
};

export const markEffectiveDateAutoUpdateFailed = (
  applicationGroupId: string
): void => {
  try {
    sessionStorage.setItem(keyFor(applicationGroupId), '1');
  } catch {
    // Storage unavailable: the once-per-load guard still applies.
  }
};
